import React from "react"
import Modal from "aldoo-ra/Modal"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Button from "aldoo-ra/Button"
import { ChevronLeftIcon } from "@heroicons/react/20/solid"
import Typography from "aldoo-ra/Typography"

export default function MagicLinkAwaitDialog({ controller }) {
  const { provider, closeDialog, DialogType, isDialogOpen, backToSignIn } =
    controller

  return (
    <Modal
      isOpen={isDialogOpen(DialogType.MAGIC_LINK)}
      onClose={closeDialog}
      variant="mobilingo_medium"
      className="max-w-[534px]"
    >
      <CMSRender
        contentType="MagicLinkConfirmDialog"
        renderItem={(dialog) => (
          <div className="relative bg-paper w-full max-w-[408px] text-center pb-2 mx-auto">
            {/* Icon */}
            <div className="flex justify-center mb-[50px]">
              <img
                src={dialog.icon}
                alt="Email verification"
                className="w-[100px] h-[100px]"
              />
            </div>

            {/* Title */}
            <Typography
              variant="body1"
              className="mb-[30px]"
            >
              {dialog.title}
            </Typography>

            {/* Line Divider */}
            <div className="w-full border border-bordered mb-[44px] mx-auto" />

            {/* Email Display */}
            <Typography
              variant="body1_accent"
              className="mb-[50px]"
            >
              {/* Email - Please fix logic so that data is successfuly passed on here */}
              { provider.data || "sophia.parker@gmail.com" }
            </Typography>

            {/* Description */}
            <Typography variant="txt1_dim">
              {dialog.description}
            </Typography>

            {/* Back to Sign In Button */}
            <div className="w-full flex items-center justify-center mt-[24px] mx-auto">
              <Button
                variant="text_btn_ghost"
                onClick={() => {
                  closeDialog()
                  backToSignIn()
                }}
                className="flex items-center gap-2"
              >
                <ChevronLeftIcon className="w-6 h-6" />
                <span>{dialog.back_to_login_text}</span>
              </Button>
            </div>
          </div>
        )}
      />
    </Modal>
  )
}